import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

import "./styles.css";
import BigRadio from "../big-radio";
import ExperienceContent from "./content";
import { experiencePropType } from "../../model/utils";

const SingleExperience = ({ experience, hasExperience, toggleExperience }) => {
  // keep track whether we're selected or not
  const [selected, setSelected] = useState(false);
  useEffect(() => {
    setSelected(hasExperience(experience));
  }, [experience, hasExperience]);

  // toggle checked status
  const toggle = useCallback(() => toggleExperience(experience), [
    experience,
    toggleExperience
  ]);

  return (
    <div className="col-12 col-lg-6" key={experience.id}>
      <div
        styleName={"experience" + (selected ? " selected" : "")}
        onClick={toggle}
      >
        <BigRadio checked={selected} label={experience.title} />
        <div styleName="content">
          <ExperienceContent experience={experience} />
        </div>
      </div>
    </div>
  );
};

SingleExperience.propTypes = {
  experience: experiencePropType,
  hasExperience: PropTypes.func.isRequired,
  toggleExperience: PropTypes.func.isRequired
};

export default SingleExperience;
